import React, { useEffect, useState,useCallback } from 'react';
import DemandeSchema from '../components/DemandeSchema';
import { apiFetch } from '../utils/apiClient'; // ✅ import your reusable fetch hel
import ModernMonthPicker from '../components/ModernMonthPicker';

// import { io } from "socket.io-client";

// const socket = io.connect("${process.env.REACT_APP_API_BASE_URL}"); // Adapter l'URL si nécessaire

function Demande({
  user,
  checkGroupDemandeProjet,
  checkGroupAdmin,
  checkGroupSeancePlacement,
  existMembre,
  formAccess,
}) {
  const [userId, setuserId] = useState('');
  const [selectedForm, setSelectedForm] = useState('');
  const [selectedEtat, setSelectedEtat] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [numeroFormulaire, setNumeroFormulaire] = useState('');
  const [periodeReclamation, setPeriodeReclamation] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  const canAccessManagedForm = (formKey) =>
    formAccess?.restricted === false ||
    formAccess?.allowedForms?.includes(formKey) === true;
  const [sortedData, setSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [authLoading, setAuthLoading] = useState(true);
  const now = new Date();
  const currentMonth = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0')].join('-');

  useEffect(() => {
    if (user) {
      setuserId(user.id);
    }
  }, [user]);

  
    // useEffect(() => {

    //   if (userId) {
    //     // console.log("Connexion WebSocket, envoi de la requête fetchData avec groupes:", userGroups);
    
    //     socket.emit("form", { userId: userId,startDate, endDate,numeroFormulaire});
    
    //     socket.on("MesDemandeData", (data) => {
    //       // console.log("Données reçues du serveur :", data);
    //       setSortedData(data)
    //     });
    
    //     socket.on("error", (err) => {
    //       console.error("Erreur reçue du serveur:", err);
    //     });
    
    //     return () => {
    //       socket.off("MesDemandeData");
    //       socket.off("error");
    //     };
    //   }
    // },);



const fetchData = useCallback(async () => {
  if (!userId) return;

  const queryParams = new URLSearchParams({
    userId,
    ...(startDate ? { startDate } : {}),
    ...(endDate ? { endDate } : {}),
    ...(numeroFormulaire ? { numeroFormulaire } : {}),
    ...(periodeReclamation ? { periodeReclamation } : {})
  });

  try {
    const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/mes-demandes?${queryParams.toString()}`);
    if (!response.ok) {
      throw new Error("Erreur lors de la récupération des données.");
    }
    const data = await response.json();
    setSortedData(data);
    setAuthLoading(false); 
  } catch (error) {
    console.error("Erreur :", error);
  }
}, [userId, startDate, endDate, numeroFormulaire, periodeReclamation]);

useEffect(() => {
  fetchData();
}, [fetchData]); 

// ✅ plus d'avertissement

    // const fetchData = async () => {
    //   if (!userId) return;
  
    //   const queryParams = new URLSearchParams({
    //     userId,
    //     ...(startDate ? { startDate } : {}),
    //     ...(endDate ? { endDate } : {}),
    //     ...(numeroFormulaire ? { numeroFormulaire } : {})
    //   });
  
    //   try {
    //     const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/mes-demandes?${queryParams.toString()}`);
    //     if (!response.ok) {
    //       throw new Error("Erreur lors de la récupération des données.");
    //     }
    //     const data = await response.json();
    //     setSortedData(data);
    //     console.log(data)
    //   } catch (error) {
    //     console.error("Erreur :", error);
    //   }
    // };
    // useEffect(() => {
      
    //   fetchData();
    // }, [userId, startDate, endDate, numeroFormulaire]); // Ajoute les dépendances nécessaires
    

  // Filtrage des données
  const filteredData = Array.isArray(sortedData)
  ? sortedData.filter(item => {
      const matchesForm = selectedForm ? item.formulaire === selectedForm : true;
      const matchesEtat = selectedEtat ? item.etatDemande === selectedEtat : true;
      return matchesForm && matchesEtat;
    })
  : [];
  const handleDropdownChange = (event) => {
    const formType = event.target.value;
    setSelectedForm(formType);
    if (formType !== 'Réclamation mensuelle de dépenses') {
      setPeriodeReclamation('');
    }
    setCurrentPage(1)
  };

  const handlePeriodeReclamationChange = (event) => {
    const periode = event.target.value;
    setPeriodeReclamation(periode);
    if (periode) {
      setSelectedForm('Réclamation mensuelle de dépenses');
      setStartDate('');
      setEndDate('');
    }
    setCurrentPage(1);
  };

  const handleEtatChange = (event) => {
    setSelectedEtat(event.target.value);
    setCurrentPage(1)
  };

  const handleClearFilters = () => {
    setSelectedForm('');
    setSelectedEtat('');
    setNumeroFormulaire('');
    setStartDate('');
    setEndDate('');
    setPeriodeReclamation('');
    setCurrentPage(1)
  };

  const activeFiltersCount = [
    selectedForm,
    selectedEtat,
    numeroFormulaire,
    startDate,
    endDate,
    periodeReclamation,
  ].filter(Boolean).length;

  return (
    <div className="min-h-screen p-4">
      <div className="mb-4 ml-4 flex items-center gap-4">
      <button
        type="button"
        onClick={() => setShowFilters((visible) => !visible)}
        className={`inline-flex items-center gap-2 rounded-2xl border px-4 py-3 text-sm font-semibold shadow-sm transition-all duration-200 hover:shadow-md ${
          showFilters
            ? "border-blue-600 bg-blue-600 text-white hover:bg-blue-700"
            : "border-blue-400 bg-white text-blue-700"
        }`}
        aria-expanded={showFilters}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-5 w-5 ${showFilters ? "text-white" : "text-slate-500"}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z"
          />
        </svg>
        <span>Filtres</span>
        {activeFiltersCount > 0 && (
          <span
            className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-white px-1.5 text-xs font-bold text-blue-700"
          >
            {activeFiltersCount}
          </span>
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-4 w-4 transition-transform duration-200 ${
            showFilters ? "rotate-180 text-white" : "rotate-0 text-slate-400"
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
        <span className="hidden text-sm text-slate-500 md:inline">
          Filtrer les demandes rapidement
        </span>
      </div>
      {showFilters && (
  <div className="mx-4 flex flex-wrap items-end gap-4 mb-6 bg-white p-6 text-sm rounded-2xl shadow-lg border border-gray-200 transition-all duration-300">
    
    {/* Filtre Formulaire */}
    <div className="flex flex-col">
      <label htmlFor="formFilter" className="mb-1 text-sm font-semibold text-gray-700">Formulaire</label>
      <select
        id="formFilter"
        value={selectedForm}
        onChange={handleDropdownChange}
        className="h-12 p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
      >
        <option value="">Tous les formulaires</option>
        {canAccessManagedForm("AccesHP") && <option value="Accès hors pays">Accès hors pays</option>}
        {canAccessManagedForm("ReseauInfo") && <option value="Accès au compte informatique">Accès au compte informatique</option>}
        {canAccessManagedForm("AchatEI") && <option value="Achat équipement informatique">Achat équipement informatique</option>}
        {canAccessManagedForm("AntecedentCriminel") && <option value="Antécédents criminels">Antécédents criminels</option>}
        {canAccessManagedForm("Adresse") && <option value="Changement adresse">Changement d'adresse</option>}
        {canAccessManagedForm("Nom") && <option value="Changement de nom">Changement de nom</option>}
        {canAccessManagedForm("InfoBancaire") && <option value="Changement information bancaire">Changement information bancaire</option>}
        {(existMembre === "exist dans AEFO" || checkGroupAdmin || checkGroupSeancePlacement) && (
          <option value="Demande AEFO">Demande AEFO</option>
        )}
        {(existMembre === "exist dans FEESO" || checkGroupAdmin || checkGroupSeancePlacement) && (
          <option value="Demande FEESO">Demande FEESO</option>
        )}
        {(existMembre === "exist dans SCFP" || checkGroupAdmin || checkGroupSeancePlacement) && (
          <option value="Demande SCFP">Demande SCFP</option>
        )}
        {checkGroupDemandeProjet === true && canAccessManagedForm("DemandeProjet") && (
          <option value="Demande de projet">Demande de projet</option>
        )}
        {canAccessManagedForm("EntenteTravailHybrid") && <option value="Entente de travail en mode hybrid">Entente de travail en mode hybrid</option>}
        {canAccessManagedForm("ReclamationDepense") && <option value="Réclamation mensuelle de dépenses">Réclamation mensuelle de dépenses</option>}
        
      </select>
    </div>

    {/* Filtre Mois des dépenses */}
    <div className="flex flex-col">
      <label htmlFor="periodeReclamation" className="mb-1 text-sm font-semibold text-gray-700">Mois des dépenses</label>
      <ModernMonthPicker
        value={periodeReclamation}
        onChange={(value) => handlePeriodeReclamationChange({ target: { value } })}
        max={currentMonth}
        ariaLabel="Choisir le mois des dépenses"
      />
    </div>

    {/* Filtre Statut */}
    <div className="flex flex-col">
      <label htmlFor="etatFilter" className="mb-1 text-sm font-semibold text-gray-700">Statut</label>
      <select
        id="etatFilter"
        value={selectedEtat}
        onChange={handleEtatChange}
        className="h-12 p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
      >
        <option value="">Tous</option>
        <option value="Brouillon">Brouillon</option>
        <option value="Supprimé">Supprimé</option>
        <option value="En attente">En attente</option>
        <option value="En traitement">En traitement</option>
        <option value="Approuvé">Approuvé</option>
        <option value="Rejeté">Rejeté</option>
        <option value="Soumis">Soumis</option>
      </select>
    </div>

    {/* Filtre Numéro */}
    <div className="flex flex-col">
      <label htmlFor="numeroFormulaire" className="mb-1 text-sm font-semibold text-gray-700">Numéro du Formulaire</label>
      <input
        type="text"
        id="numeroFormulaire"
        value={numeroFormulaire}
        onChange={(e) => {
          setNumeroFormulaire(e.target.value);
          setCurrentPage(1);
        }}
        placeholder="Entrez le numéro"
        className="h-12 p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
      />
    </div>

    {/* Filtre Période de soumission */}
    {periodeReclamation ? (
      <div className="flex min-w-[330px] flex-col">
        <span className="mb-1 text-sm font-semibold text-gray-700">
          Période de soumission
        </span>
        <div className="flex h-12 items-center gap-2 px-1 text-sm text-slate-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 shrink-0 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>Toutes les dates de soumission sont incluses.</span>
        </div>
      </div>
    ) : (
      <div className="flex min-w-[330px] flex-col">
        <span className="mb-1 text-sm font-semibold text-gray-700">
          Période de soumission
        </span>
        <div className="flex items-center gap-2">
          <div className="flex flex-1 flex-col">
            <label htmlFor="startDate" className="sr-only">
              Date de début de la période de soumission
            </label>
            <input
              type="date"
              id="startDate"
              value={startDate}
              onChange={(e) => { setStartDate(e.target.value); setCurrentPage(1); }}
              className="h-12 p-3 text-sm border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
            />
          </div>
          <span className="mt-0 text-gray-400" aria-hidden="true">→</span>
          <div className="flex flex-1 flex-col">
            <label htmlFor="endDate" className="sr-only">
              Date de fin de la période de soumission
            </label>
            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={(e) => { setEndDate(e.target.value); setCurrentPage(1); }}
              className="h-12 p-3 text-sm border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
            />
          </div>
        </div>
      </div>
    )}
    {/* Bouton Réinitialiser */}
    <div className="flex items-end">
      <button
        type="button"
        onClick={handleClearFilters}
        className="inline-flex h-12 items-center gap-2 rounded-lg px-2.5 text-sm font-semibold text-blue-600 transition-colors duration-200 hover:bg-blue-50 hover:text-blue-800"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4 4v5h5M20 20v-5h-5M5.64 18.36A8 8 0 0018.36 5.64M18.36 5.64A8 8 0 005.64 18.36"
          />
        </svg>
        <span>Réinitialiser</span>
      </button>
    </div>

  </div>
)}


      {/* {filteredData.length > 0 ? ( */}
        <DemandeSchema 
          formData={filteredData}   
          currentPage ={currentPage} 
          setCurrentPage ={setCurrentPage} 
          fetchData={fetchData}
          user={user}
          authLoading={authLoading}
          startDate={startDate}
          endDate={endDate}
          numeroFormulaire={numeroFormulaire}
          periodeReclamation={periodeReclamation}
          selectedFormFilter={selectedForm}
        />
      {/* // ) : (
      //   <p className="text-center mt-4 text-gray-500">Aucune demande trouvée.</p>
      // )} */}
    </div>
  );
}

export default Demande;
// fetchFormData={fetchFormData}
